// Every action uses the revision on screen: an older one being viewed, else the latest
// persisted revision (pending edits are saved first; a failed save stops the action).
export default function useScriptActions(s, onTeleprompter, onMobile, revision = null) {
  const withSaved = async fn => {
    try {
      const saved = revision || await s.savedRevision();
      if (saved) await fn(saved);
    } catch { s.setError('generic'); }
  };
  const download = format => s.exportScript(format, revision);
  const copy = () => withSaved(async saved => {
    await navigator.clipboard.writeText(saved.script.spoken_text);
    window.setSnackbar(s.t('copied'));
  });
  const openTeleprompter = () => withSaved(onTeleprompter);
  const openMobile = () => withSaved(onMobile);
  return { download, copy, openTeleprompter, openMobile };
}
